export default __webpack_public_path__ + "static/media/manali2.e3651bcc.webp";